import { atom } from 'recoil';
import { IHeaderInfo } from '../types/company';

export const headerInfoAtom = atom<IHeaderInfo | undefined>({
  key: 'headerInfoAtom',
  default: undefined,
});
